export default "__VITE_ASSET__CrrlAI2K__"